import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {DomSanitizer, SafeResourceUrl, Title} from '@angular/platform-browser';

// See if these imports are needed
import { ApiService } from '../../../services/api.service';
import { UtilityService } from '../../../services/utility-service';
// import { Constants } from '../../../constants/ebtq-constants';
import {ViewPurchaseAdvice} from '../../../model/viewPurchaseAdvice';
import {Router} from '@angular/router';
import { interval, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { LoaderService } from '../../../shared/loader/service/loader.service';
import { AdhocReportWrapper } from '../../../model/AdhocReportWrapper';
import { LoanWrapper } from '../../../model/loanWrapper';
import { saveAs } from 'file-saver';
import { TransactionWrapper } from '../../../model/transactionWrapper';
import { Constants } from '../../../constants/ebtq-constants';

@Component({
  standalone: false,
  selector: 'app-accounting-view-purchase-advice',
  templateUrl: './accounting-view-purchase-advice.component.html',
  styleUrls: ['./accounting-view-purchase-advice.component.scss']
})
export class AccountingViewPurchaseAdviceComponent implements OnInit {

  warningMessage!: string;
  errorMessage: string[] = [];
  containsError = false;
  errorMsg!: string;
  servicerNumbers!: any[];
  selectedServicerNumber!: object[];
  purchase!: ViewPurchaseAdvice;
  title = 'View Purchase Advice';
  reportDate!: string;
  isExcel!: boolean;
  ssn!: string;
  lndrNbr!: string;
  loanNbr!: string;
  safePdfURL?: SafeResourceUrl;
  displayDialog = false;
  fileData!: Blob;
  fileName!: string;

  viewPurchaseAdviceLoanCriteriaForm = new UntypedFormGroup({
    loanNumber: new UntypedFormControl('')
  });

  viewPurchaseAdviceLenderCriteriaForm = new UntypedFormGroup({
    lenderLoanID: new UntypedFormControl(''),
    servicerNumber: new UntypedFormControl(''),
    date: new UntypedFormControl('')
  });

  constructor(private apiService: ApiService, private router: Router,
              private _utility: UtilityService, private titleService: Title,
              private loaderService: LoaderService,  public sanitizer: DomSanitizer,
              private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.purchase = new ViewPurchaseAdvice();
    this.purchase.isExternal = JSON.parse(sessionStorage.getItem('isExternal') ?? 'false');
    this.purchase.isServicingUpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_Update') ?? 'false');
    this.purchase.isServicingView = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_View') ?? 'false');

    this.warningMessage = '';
    this.errorMessage = [];
    this.servicerNumbers = [];

    this.loadServicerNumber();
    this.onLenderCriteriaClear();
    this.onLoanCriteriaClear();


  }

  loadServicerNumber() {
    // Retrieves all the servicer numbers associated with the current external user
    if (this.purchase.isExternal && (this.purchase.isServicingView || this.purchase.isServicingUpdate) &&
      (sessionStorage.getItem('authServrList') != null))
    {

      this.servicerNumbers = Array.from(JSON.parse(sessionStorage.getItem('authServrList') ?? '[]'));
      this.viewPurchaseAdviceLenderCriteriaForm.controls['servicerNumber'].setValue(this.servicerNumbers[0].value);

    }
  }

  onSubmit(isLoanNbr: boolean): void {
    if (!this.validInput(isLoanNbr, true)) {
      return;
    }

    this.loaderService.isLoaderOn.next(true);

    if (!isLoanNbr) {
      const wrp = new AdhocReportWrapper();
      wrp.reportName = 'Purchase_Advice_by_Servicer_Report';
      wrp.parameters!.push('ALL');

      let lndrNbr = this.viewPurchaseAdviceLenderCriteriaForm.value.lenderLoanID;
      if (lndrNbr === undefined || lndrNbr === null || lndrNbr === '') {
        lndrNbr = 'ALL';
      }
      let date = this.reportDate;
      if (date === undefined || date === null || date === '') {
        date = 'ALL';
      }
      wrp.parameters!.push(lndrNbr);
      wrp.parameters!.push(this.viewPurchaseAdviceLenderCriteriaForm.value.servicerNumber.toString());
      wrp.parameters!.push(date);
      this.callGenerate(wrp);
    }
  }
  private callGenerate(wrp: AdhocReportWrapper) {
    if (!this.isExcel) {
      this.apiService.generateAdhocReport(wrp).subscribe((res) => {
        this.retrieveFile(res.fileName ?? '', true);
      }, (err) => {
        if (err.error && err.error.message) {
          this.warningMessage = err.error.message;
        } else {
          this.warningMessage = err;
        }
        this.loaderService.isLoaderOn.next(false);
        this.cdr.detectChanges();
      });
    }
  }

  downloadExcel(isLoanNbr: boolean) {
    this.isExcel = true;
    if (!this.validInput(isLoanNbr, false)) {
      return;
    }


    const wrp = new LoanWrapper();
    const qm = wrp.queryMap as Record<string, any>;
    if (isLoanNbr) {
      qm['fnmeLoanNumber'] = this.viewPurchaseAdviceLoanCriteriaForm.value.loanNumber;
    } else {
      qm['lenderLoanNumber'] = this.viewPurchaseAdviceLenderCriteriaForm.value.lenderLoanID;
      qm['PurchaseDt'] = this.reportDate;
      qm['servicerNumber'] = this.viewPurchaseAdviceLenderCriteriaForm.value.servicerNumber.toString();
    }
    wrp.seller = false;

    this.apiService.getPurchaseAdviceReport(wrp).subscribe((data) => {
      const fileName = (data.headers.get('Content-Disposition').split('filename='))[1];
      saveAs(data.body, fileName);
    }, (err) => {
      if (err.error && err.error.message) {
        this.warningMessage = err.error.message;
      } else {
        this.warningMessage = err;
      }
      this.cdr.detectChanges();
    });
    this.isExcel = false;
  }

  retrieveFile(fileName: string, isPdf: boolean): void {
    const stopPolling = new Subject<void>();
    let loopCnt = 0;
    interval(9000).pipe(
      switchMap(() => this.apiService.checkAdhocReportGenerated(fileName)),
      takeUntil(stopPolling)
    ).subscribe((data: any) => {
      loopCnt = loopCnt + 1;
      if ((typeof data === 'string' && 'No Matching Report Found' !== data) || loopCnt > 10) {
        stopPolling.next();
        this.warningMessage = data;
        this.loaderService.isLoaderOn.next(false);
        this.cdr.detectChanges();
        return;
      } else if ('No Matching Report Found' === data) {
        return;
      }
      this.fileName = (data.headers.get('Content-Disposition').split('filename='))[1];
      if (isPdf) {
        const blob = new Blob([data.body], {type: 'application/pdf'});
        const fileURL = window.URL.createObjectURL(blob) + '#toolbar=0';
        this.safePdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        this.displayDialog = true;
        this.fileData = data.body;
      } else {
        saveAs(data.body, this.fileName);
      }
      stopPolling.next();
      this.loaderService.isLoaderOn.next(false);
      this.cdr.detectChanges();
    }, (err) => {
      if (err.error && err.error.message) {
        this.warningMessage = err.error.message;
      } else {
        this.warningMessage = err;
      }
      this.loaderService.isLoaderOn.next(false);
      this.cdr.detectChanges();
    });
  }

  private validInput(isLoanNbr: boolean, isPdf: boolean) {

    if (!isLoanNbr) {
      this.onLoanCriteriaClear();
      this.ssn = this.viewPurchaseAdviceLenderCriteriaForm.value.servicerNumber;
      this.lndrNbr = this.viewPurchaseAdviceLenderCriteriaForm.value.lenderLoanID;
      const date = this.viewPurchaseAdviceLenderCriteriaForm.value.date;
      if (date === null || date === undefined) {
        this.reportDate = '';
      } else {
        const dateMilli = this._utility.convertDateToMillisec(date);
        this.reportDate = this._utility.convertMillisecToDate(dateMilli);
      }
    } else {
      this.onLenderCriteriaClear();
      this.loanNbr = this.viewPurchaseAdviceLoanCriteriaForm.value.loanNumber;
    }

    if (!this.purchaseAdviceReportValidation()) {

      this.errorMessage.push('Invalid search combination, please try again.');
    }
    if (this.isNotBlank(this.ssn) && this.containsIllegalCharacter(this.ssn)) {
      this.errorMessage.push('Servicer Number contains invalid characters');
    }
    // both
    if (this.isNotBlank(this.lndrNbr) && (this.lndrNbr.length > 15)) {
      this.errorMessage.push('Lender Loan ID is invalid');
    }
    if ((this.isNotBlank(this.reportDate)) && (!this.isValidDate(this.reportDate))) {
      this.errorMessage.push('Please check the date format is MM/DD/YYYY');
    }
    if (this.errorMessage.length === 0) {
      if (this.purchase.isExternal && this.isNotBlank(this.loanNbr)) {
        return this.isUserAuthorizedForLoanNumber(this.loanNbr, isPdf);
      } else if (isLoanNbr) {
        this.callGenerateWrapper();
      }
      if (this.purchase.isExternal && this.isNotBlank(this.ssn)) {
        if (!this._utility.isUserAuthorizedForServicerNumber(this.ssn)) {
          this.errorMessage.push('User not authorized for servicer number: ' + this.ssn);
          return false;
        }
      }
    }
    return !(this.errorMessage.length > 0);
  }
  containsIllegalCharacter(str: string) {
    if ( this.isBlank(str) || str === 'null' ) {
      return false;
    }
    const illegalString = '<>="\'%;)(&+\\?~|^*[]-{}$';
    for (let i = 0; i < str.length; i++) {
      if (illegalString.includes(str.charAt(i))) {
        return true;
      }
    }
    return false;
  }

  purchaseAdviceReportValidation() {
    let validcombination = false;


    if ((this.isNotBlank(this.loanNbr) && this.isValidFannieMaeLoanNumber(this.loanNbr))
        && this.isBlank(this.lndrNbr)
        && this.isBlank(this.ssn)
        && this.isBlank(this.reportDate)) {
      // Situation A. only thing entered is a FNM Loan Num
      validcombination = true;

    } else if (this.isNotBlank(this.ssn)
        && this.isNotBlank(this.lndrNbr)
        && this.isBlank(this.reportDate)
        && this.isBlank(this.loanNbr)) {
      // Situation B . Servicer Number & Servicer Loan Number
      validcombination = true;
    } else if (this.isNotBlank(this.ssn)
        && this.isNotBlank(this.reportDate)
        && this.isBlank(this.lndrNbr)
        && this.isBlank(this.loanNbr)) {
      // Situation C . Servicer Number & Purchase Date
      validcombination = true;
    } else if (this.isNotBlank(this.ssn)
        && this.isNotBlank(this.reportDate)
        && this.isNotBlank(this.lndrNbr)
        && this.isBlank(this.loanNbr)) {
      // Situation D. Servicer Number & Purchase Date & Servicer Loan Number
      validcombination = true;
    }

    return validcombination;
  }

  isValidFannieMaeLoanNumber(loanNbr: string) {
    let isValidFNMLoanNumber = true;

    if (loanNbr.trim().length !== 10
        || !this.isLong(loanNbr)
        || !loanNbr.startsWith('6')) {

      isValidFNMLoanNumber = false;
    }
    return isValidFNMLoanNumber;
  }

  isUserAuthorizedForLoanNumber(loanNbr: string, isPdf: boolean) {
    let isAuthorized = true;
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
    transactionWrapper.parameters![0] = loanNbr;
    this.apiService.executeQuery(transactionWrapper)
      .subscribe(
        (data: any) => {
          if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
            // Checks if user is external and they clicked the "Submit" button
            /* If an external user enters an invalid loan number that starts with '6' and clicks "Submit", they will
               see the loan is not active warning message, and this message only applies to external users. Internal users do
               not see this warning message.
            */
            if (isPdf && this.purchase.isExternal)
            {
              this.warningMessage = Constants.LOAN_NOT_ACTIV;
              isAuthorized = false;
            }
          } else {
            const srvrNo = data.object[0].SRVR_NO;
            if (!this._utility.isUserAuthorizedForServicerNumber(srvrNo)) {
              // Checks if user is external and they clicked the "Submit" button
              /* If an external user tries to view a loan number not associated with their servicer number, they will
                 see that they are not authorized for that loan. Internal users can view any loan so this warning
                 message does not apply to them.
              */
              if (isPdf && this.purchase.isExternal)
              {
                this.warningMessage = 'User not authorized for Loan: ' + loanNbr + '.';
                isAuthorized = false;
              }
            } else if (isPdf) {
              this.callGenerateWrapper();
            }
          }
          this.cdr.detectChanges();
        },
        error => {
          this.warningMessage = error;
          isAuthorized = false;
          this.cdr.detectChanges();
        });
    return isAuthorized;
  }

  private isNotBlank(s : string): boolean {
    let isValid = false;
    if (s !== null && s !== undefined) {
      isValid = true;
      if (typeof s == 'string' && s.trim().length === 0) {
        isValid = false;
      }
    }
    return  isValid;
  }

  private isBlank(s: string): boolean {
    return !this.isNotBlank(s);
  }

  private callGenerateWrapper() {
    this.loaderService.isLoaderOn.next(true);
    const wrp = new AdhocReportWrapper();
    wrp.reportName = 'Purchase_Advice_by_Servicer_Report';
    wrp.parameters!.push(this.viewPurchaseAdviceLoanCriteriaForm.value.loanNumber);
    wrp.parameters!.push(...['ALL', 'ALL', 'ALL']);
    this.callGenerate(wrp);
  }
  private isLong(filed: string) {
    return /^[-]?[0-9]+$/.test(filed);
  }

  isValidDate(dateString: string) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    }

    // Parse the date parts to integers
    const parts = dateString.split('/');
    const day = parseInt(parts[1], 10);
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[2], 10);

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }
    // Check the range of the day
    const validDate =  day > 0 && day <= monthLength[month - 1];

    const currentTime = new Date();
    let validYear = true;
    // Check the ranges of month and year
    if (year > currentTime.getFullYear()) {
      validYear =  false;
    } else if (year < 1600) {
      validYear =  false;
    }
    return validDate && validYear && (month > 0 && month < 13);
  }

  onLoanCriteriaClear(): void {
    this.errorMessage = [];
    this.warningMessage = '';
    this.loanNbr = '';
    this.viewPurchaseAdviceLoanCriteriaForm.reset();
  }

  onLenderCriteriaClear(): void {
    this.errorMessage = [];
    this.warningMessage = '';
    this.reportDate = '';
    this.ssn = '';
    this.lndrNbr = '';
    this.viewPurchaseAdviceLenderCriteriaForm.reset();
    this.loadServicerNumber();
  }

  downloadFile() {
    saveAs(this.fileData, this.fileName);
  }
  reportPrint() {
    const iframe = document.getElementById('pdfRendererIframe') as  HTMLIFrameElement;
    iframe.contentWindow?.print();

  }
}
